import React, { useRef } from "react";
// outsource
import { Button, Modal, Row, Col } from "antd";

const PayrateBonusImportDialog = ({ open, file, onClose, onSelectFile, onDownloadTemplate, onImport }) => {
  // -------------------------- VAR --------------------------
  const fileInputRef = useRef(null);

  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <div className="payrate-bonus-import-wrap">
        <h3 className="payrate-bonus-import-title"><strong>Import csv</strong></h3>
        <div className="payrate-bonus-import-section">
          <strong>Prepare file to import</strong>
          <span>Download the template and add your Client information.</span>
        </div>
        <button
          type="button"
          className="payrate-bonus-template-link"
          onClick={onDownloadTemplate}
        >
          Download Template
        </button>
        <div className="payrate-bonus-upload-label">File to upload</div>
        <div className="payrate-bonus-upload-box">
          <Button
            size="small"
            className="payrate-bonus-select-file-btn"
            onClick={() => fileInputRef.current?.click()}
          >
            Select file
          </Button>
          {file && <span className="payrate-bonus-selected-file">{file.name}</span>}
          <input
            ref={fileInputRef}
            type="file"
            accept=".csv"
            className="payrate-bonus-file-input"
            onChange={(e) => {
              onSelectFile(e.target.files?.[0] || null);
              e.target.value = "";
            }}
          />
        </div>
        <Row gutter={[28, 0]}>
          <Col flex="1">
            <Button className="payrate-bonus-cancel-btn" block onClick={onClose}>
              Cancel
            </Button>
          </Col>
          <Col flex="1">
            <Button type="primary" className="payrate-bonus-save-btn" block onClick={onImport}>
              Import
            </Button>
          </Col>
        </Row>
      </div>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Modal
      open={open}
      title={null}
      footer={null}
      closable={false}
      centered
      width={465}
      className="payrate-bonus-import-modal"
      onCancel={onClose}
    >
      {renderBody()}
    </Modal>
  );
};

export default PayrateBonusImportDialog;
